import React, { useState, useRef, useEffect } from "react";
import "./SearchSelect.css";
import { ReactComponent as ChevronDown } from "../assets/icons/chevron-down.svg";
import { ReactComponent as Search } from "../assets/icons/search.svg";

export default function SearchSelect({
  placeholder,
  focus,
  value,
  setValue,
  setFocus,
  list = [],
  prohibitedValue,
  withoutSearch,
  isLabeled = true,
}) {
  const ref1 = useRef(null); // Dropdown container ref
  const searchRef1 = useRef(null);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null); // New ref for detecting outside clicks
  const optionRefs = useRef([]); // Array of refs for options
  const [searchItem, setSearchItem] = useState("");
  const [label, setLabel] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);

  useEffect(() => {
    if (isLabeled && value !== "" && list.length > 0) {
      setLabel(list.find((lang) => lang.value === value)?.label || "");
    }
  }, [value, list, isLabeled]);

  // Detect clicks outside dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setFocus(false);
      }
    }

    if (focus) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [focus, setFocus]);

  const filteredList = isLabeled
    ? list.filter((item) =>
      item.value.toLowerCase().includes(searchItem.toLowerCase())
    )
    : list.filter((item) =>
      item.toLowerCase().includes(searchItem.toLowerCase())
    );

  // Handle Key Press Events with Scroll Support
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setActiveIndex((prev) => {
        let newIndex = prev < filteredList.length - 1 ? prev + 1 : 0;
        scrollToItem(newIndex);
        return newIndex;
      });
    } else if (e.key === "ArrowUp") {
      setActiveIndex((prev) => {
        let newIndex = prev > 0 ? prev - 1 : filteredList.length - 1;
        scrollToItem(newIndex);
        return newIndex;
      });
    } else if (e.key === "Enter" && activeIndex !== -1) {
      const selectedItem = filteredList[activeIndex];
      if (isLabeled) {
        setValue(selectedItem.value);
        setLabel(selectedItem.label);
      } else {
        setValue(selectedItem);
      }
      setSearchItem("");
      setFocus(false);
    } else if (e.key === "Escape") {
      setFocus(false);
    }
  };

  // Function to scroll selected item into view
  const scrollToItem = (index) => {
    if (optionRefs.current[index]) {
      optionRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

  return (
    <div ref={dropdownRef} className="servicesSelectOrdercontainer" onKeyDown={handleKeyDown} tabIndex={0}>
      <input
        ref={inputRef}
        onClick={() => setFocus(!focus)}
        readOnly
        className={
          value === ""
            ? focus
              ? "servicesSelectOrder servicesSelectOrderOpened"
              : "servicesSelectOrder"
            : focus
              ? "servicesSelectOrder servicesSelectOrderOpened"
              : "servicesSelectOrder servicesSelectNotEmpty"
        }
        value={value && isLabeled ? label : value}
      />

      <span
        className={
          value === ""
            ? "servivesElectPlaceholder"
            : "servivesElectPlaceholder servicesSelectPlaceholderFocus"
        }
      >
        {placeholder}
      </span>
      <ChevronDown
        onClick={() => setFocus(!focus)}
        className={
          focus
            ? "servicesChevronDown servicesChevronFocused"
            : "servicesChevronDown"
        }
      />

      {focus && (
        <div ref={ref1} className="translationLanguageOptions">
          {!withoutSearch && (
            <div className="languageSearchForm">
              <input
                value={searchItem}
                autoFocus
                onChange={(e) => setSearchItem(e.target.value)}
                placeholder="Search"
                className="languageSearchFormsInput"
                ref={searchRef1}
              />
              <Search className="languageSearchFormIcon" />
            </div>
          )}

          <div className="countryListContainer" id="searchCountryContainer">
            {filteredList.map((item, i) => (
              <div
                key={i}
                ref={(el) => (optionRefs.current[i] = el)} // Assign ref to each option
                className={`languageWrapper cursor-pointer ${activeIndex === i ? "highlighted" : ""
                  }`}
                onMouseEnter={() => setActiveIndex(i)}
                onClick={() => {
                  setFocus(false);
                  if (isLabeled) {
                    setValue(item.value);
                    setLabel(item.label);
                  } else {
                    setValue(item);
                  }
                  setSearchItem("");
                }}
              >
                <div
                  key={isLabeled ? item.value : item}
                  className="translationLanguageOption"
                >
                  {isLabeled ? item.label : item}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
